module.exports = {
  APP_PLATFORMS: {
    JIRA: 'JIRA',
    WEB_APP: 'WEB_APP',
    WEB_APP_LOGIN: 'WEB_APP_LOGIN',
    CROSS_PLATFORM: 'CROSS_PLATFORM',
    CROSS_PLATFORM_INSTALLATION: 'CROSS_PLATFORM_INSTALLATION',
    SSO_REQUIRED: 'SSO_REQUIRED',
    AFTER_LOGIN_MS: 'AFTER_LOGIN_MS',
    AZURE_DEVOPS: 'AZURE_DEVOPS',
    AZURE_DEVOPS_SETTINGS: 'AZURE_DEVOPS_SETTINGS',
    AZURE_DEVOPS_WIDGET: 'AZURE_DEVOPS_WIDGET'
  }
}
